import { Component, Injector, TemplateRef, ViewChild } from '@angular/core';
import { AbstractBuilderComponent, BuilderDataAbstract } from '../../shared/components/abstract-builder/abstract-builder.component';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { HistoryData } from '../../../../shared/components/history-view/history-view.component';
import { validateAllFormFields } from '../../../../shared/validators';
import { LoadingStateService } from '../../../../shared/services/common/loading-state.service';
import { BuilderData } from '../../../../shared/models/clincal-note.model';

interface BGTestFormData extends BuilderDataAbstract {
  fasting: boolean;
  result: number;
  note: string;
  _modified: number;
}

@Component({
  selector: 'app-blood-glucose-test',
  templateUrl: './blood-glucose-test.component.html',
  styleUrls: ['./blood-glucose-test.component.scss']
})
export class BloodGlucoseTestComponent extends AbstractBuilderComponent {
  @ViewChild('preview') preview!: TemplateRef<unknown>;

  constructor(
    private fb: FormBuilder
  ) {
    super();
    this.formData = this.fb.group({
      fasting: [null, Validators.required],
      result: [null, Validators.required],
      note: [null, Validators.maxLength(500)]
    });
  }

  protected getBuilderData(): BuilderData {
    const data = this.formData.getRawValue() as BGTestFormData;

    let builderData = this.data;
    if (!builderData) {
      builderData = data;
    } else {
      builderData = data;
    }
    return builderData;
  }

  public override async validate() {
    validateAllFormFields(this.formData);

    return this.formData.valid;
  }

  serialize(data: BGTestFormData): HistoryData[] {
    if (!data) {
      return [];
    }

    return [{
      type: 'builder',
      builderTitle: 'BLOOD GLUCOSE:',
      author: data.author ? data.author.name : '',
      dateTime: moment(data._modified!).format(),
      template: [this.preview, data]
    }];
  }

  asString(data: BGTestFormData): string {
    if (!data) return '';

    return [
      `[${moment(data._modified!).format('YYYY-MM-DD HH:mm')}${data.author ? `; ${data.author.name}` : ''}]: BLOOD GLUCOSE`,
      `${data.fasting ? 'Fasting' : 'Non-fasting'} - ${data.result}mmol/l${data.note ? '; ' + data.note : ''}`
    ].join('\n');
  }
}
